// extracted by mini-css-extract-plugin
module.exports = {"tabs":"_be003ad","jackpotText":"_1662f3a","jackpotTitle":"_5c62d4a","boxFontSizeSmall":"_964b16f","boxFontSizeSmaller":"_12fd809"};